import { render } from "./AdminCreateForm.vue?vue&type=template&id=9d05d3c2&scoped=true"
import script from "./AdminCreateForm.vue?vue&type=script&lang=js"
export * from "./AdminCreateForm.vue?vue&type=script&lang=js"

import "./AdminCreateForm.vue?vue&type=style&index=0&id=9d05d3c2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d05d3c2"]])

export default __exports__